<template>
<div>
    <v-text-field
        disabled
        readonly
        :value="profile.organization_summary.organization_id"
        label="Organization Id"
        autocomplete="off"
    />

    <m-edit-text
        v-model="profile.organization_summary.label"
        label="Organization Name"
        autocomplete="off"
        v-on:input="onChange"
    />

    <m-edit-select
        label="Industry"
        v-model="profile.organization_summary.industry"
        :possible_values="$rc.enumChoices('industry_code',false)"
        v-on:input="onChange"
        :return-object="false"
    />

    <m-edit-select
        label="Primary Time Zone"
        v-model="profile.organization_summary.primary_timezone"
        :possible_values="$rc.commonTimeZones()"
        v-on:input="onChange"
        :return-object="false"
    />

    
    <m-edit-select
        label="Headquarter Location"
        v-model="profile.organization_summary.country_and_subdivision"
        :possible_values="$rc.locationChoices()"
        v-on:input="onChange"
        :return-object="false"
    />
    
    
    <v-checkbox
        style="margin-top: -5px"
        label="Archived"
        v-model="profile.organization_summary.is_archived"
        v-on:change="onChange"
    />

    
    <v-checkbox
        style="margin-top: -15px"
        label="Non-Revenue"
        v-model="profile.organization_summary.is_non_revenue_account"
        v-on:change="onChange"
    />

    <v-checkbox
        style="margin-top: -15px"
        label="RedChirp Promotion Prohibited"
        v-model="profile.organization_summary.red_chirp_promotion_prohibited"
        v-on:change="onChange"
    />
    
    <m-edit-tags
        label="Organization Origin (a.k.a. Promos)"
        applies_to="organization-origin"
        v-model="profile.organization_summary.rc_tag_ids"
        v-on:input="onChange"
    />
</div>
</template>

<script>
export default {
    props: {
        profile: {
            type: Object,
            default: function() { return null; }
        },
    },

    methods: {
        onChange() {
            this.profile.organization_summary.is_revenue_account = !this.profile.organization_summary.is_non_revenue_account;

            this.$rc.rest({
                'spinner': true,
                'endpoint': 'PUT: /api/v1/red-chirp-crm/organizations',
            
                'params': this.profile.organization_summary,
            
                'on_success': (data) => {
                        this.$emit('reload');
                    },
            
                'on_error': 'Unable to save organization general information',
            });
        },

      
    },
}
</script>

<style lang="scss" scoped>

</style>